/* eslint-disable @angular-eslint/use-lifecycle-interface */
import { Component, OnInit, Input } from '@angular/core';

import { OrderPipe } from 'ngx-order-pipe';

export interface TableHeader {
  name: string;
  key: string;
  isSortable?: boolean;
  action?: () => {};
}
export interface TableRows {
  body: string;
  key: string;
  classLinkInformation?: string;
  classLinkDelete?: string;
  pipeUse: string;
  action?: () => {};
}

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css'],
})
export class TableComponent implements OnInit {
  @Input() headers: TableHeader[] = [];
  @Input() rows: Record<string, any>[] = [];

  // @Input() rows: any[] = [];

  // option  headerTableOrange -headerTableGrey  -headerTableWhite
  @Input() colorBackground: string = ''
  // tableGralStyleGrey -  tableGralOrange  - tableGralWhite
  @Input() tableStyleGeneral: string = ''

  // todo: tipo de  tabla  option
  // 'table-request-profile'
  // 'table-request-dashboard'
  // 'table-activities'
  // 'table-task'


  @Input() tableType: string = ''

  @Input() isFiltered: Boolean = false;
  @Input() isPaginate: Boolean = false;
  // cantidad de  intem por paginas

  headerKey: string[] = []
  @Input() isSortable: boolean = false;

  getInFoData() {
    if (this.rows) {
      this.rows.map((rowInfo) => {

      })

    }

  }

  constructor(private orderPipe: OrderPipe) {
    this.rows = this.rows.slice();
    this.sortedCollection = orderPipe.transform(this.rows, 'rows');
  }

  ngOnInit(): void {

  }

  /// Sortin Table
  sortedCollection: any = []
  orderActivities: string = ''
  reverse: boolean = false;
  order: string = ''

  // 1 -> disabled ; 2 -> asc ; 3 -> desc
  orderStatus: 1 | 2 | 3 = 1;

  setOrder(headerName: string) {
    if (this.order !== headerName) {
      this.orderStatus = 2;
      this.order = headerName;
    }
    else if (this.orderStatus < 3) {
      this.orderStatus++;
    }
    else {
      this.orderStatus = 1;
      this.order = '';
    }

    if (this.orderStatus === 3) {
      this.reverse = true;
    }
    else {
      this.reverse = false;
    }
  }
  getSortingStatusImage(orderStatus: 1 | 2 | 3, arrow: 'UP' | 'DOWN') {
    if (arrow === 'UP') {
      if (orderStatus === 2) {
        return 'assets/img/arrow_r_g.png';
      }
      return 'assets/img/arrow_b_g.png';
    }

    if (orderStatus === 3) {
      return 'assets/img/arrow_r_g.png';
    }
    return 'assets/img/arrow_b_g.png';
  }

}
